import api from '../../../api/_inventaire'

export default {
    getListeInventaire(data) {
        return new Promise((resolve, reject) => {
            api.getListeInventaire(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}